module.exports = __webpack_public_path__ + "download/img/jkb_button.84aea004.png";